import React from 'react';
import { renderToString } from 'react-dom/server';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { Receivable } from 'services/action';

import { Print } from 'ui/components';
import { formatDate, currencyFormat, terbilang } from 'utilities/common';

import logoBlack from 'ui/assets/envio-black.png';

const PrintReceivable = ({ match }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Show']
  );
  const [data, setData] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);
  const [page, setPage] = React.useState(null);
  const [firstPage, setFirstPage] = React.useState(15);

  const $onLoad = async (id) => {
    const req = await Dispatch(Receivable.$show(id));
    if (req?.message === 'success') {
      setData(req?.data);
    }
  };

  React.useEffect(() => {
    setLoaded(false);

    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    if (data) {
      let chunks = _.chunk(data?.products, firstPage)
      let pages = [];

      _.each(chunks, function(d, k) {
        if (chunks?.length === 1) {
          if (d?.length > 10) {
            let nd = d.splice(0, d?.length-1)
            let last = d[d?.length - 1]

            setFirstPage(nd?.length);
            pages.push(nd, [last])
          }else{
            pages.push(d)
          }
        } else {
          if (k > 1) {
            var tb = pages[k-1]?.length
            let nd = []
            let lastd = d[d?.length - 1]


            _.each(d, function(dn, kn) {
              if (k === chunks?.length-1) {
                if (lastd?.id === dn?.id) {
                  nd.push(dn);

                  return;
                }
              }

              if (tb === 20) {
                nd.push(dn);
                return;
              }

              pages[k-1].push(dn);

              tb += 1
            })

            if (nd?.length > 0) {
              pages.push(nd);
            }

            // setLimit(tb)
          }else{
            pages.push(d);
          }
        }
      })


      let no = 1;
      _.each(pages, function(p) {
        _.each(p, function(d) {
          d.no = no

          no++
        })
      })

      setPage(pages);
      setLoaded(true);
    }
  }, [data]);

  if (StateLoading || data === null || !loaded) return null;

  return (
    <div>
      <Print
        title={`Receivable - ${data?.code}`}
        size="A4"
        content={renderToString(
          <>
            {page?.map((p, id) => (
              <section
                className="sheet page-break"
                style={{ padding: '20px 60px' }}
                key={id}
              >
                {id === 0 && (
                  <>
                    <table className="body">
                      <tr style={{ verticalAlign: 'center' }}>
                        <td
                          style={{
                            textAlign: 'left',
                            paddingBottom: 15,
                            paddingTop: 30,
                            width: '50%',
                          }}
                        >
                          <p
                            className="mb-0"
                            style={{ fontSize: 30, fontWeight: 800 }}
                          >
                            {data?.document_status === 'new'
                              ? 'PROFORMA INVOICE'
                              : 'INVOICE'}
                          </p>
                          <p style={{ fontSize: 11, lineHeight: 1.5 }}>
                            PT ENVIO GLOBAL PERSADA <br />
                            GEDUNG KINANTI BUILDING LT. 2 JL EPICENTRUM TENGAH,
                            KARET KUNINGAN, SETIABUDI, KOTA ADM. JAKARTA
                            SELATAN, DKI JAKARTA, 12940
                          </p>
                        </td>

                        <td style={{ width: '50%', textAlign: 'right' }}>
                          <img src={logoBlack} alt="" height="50px" />
                        </td>
                      </tr>
                    </table>

                    <div style={{ marginTop: 10 }}>
                      <table className="body ">
                        <tr style={{ verticalAlign: 'top' }}>
                          <td
                            style={{
                              textAlign: 'left',
                              width: '40%',
                              padding: 10,
                              paddingLeft: 0,
                            }}
                          >
                            <p className="bold" style={{ fontSize: 12 }}>
                              Kepada:
                            </p>
                            <p className="mb-0" style={{ fontSize: 13 }}>
                              {data?.customer.company_name !== ''
                                ? `${data?.customer.company_name}`
                                : data?.customer?.name}
                            </p>
                            <p
                              className=""
                              style={{ fontSize: 11, lineHeight: 1.5 }}
                            >
                              {data?.billing_address || '-'}
                            </p>
                          </td>

                          <td
                            style={{
                              textAlign: 'left',
                              width: '25%',
                            }}
                          ></td>
                          <td
                            style={{
                              textAlign: 'left',
                              width: '35%',
                              padding: 10,
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                              }}
                            >
                              <p className="bold mb-0" style={{ fontSize: 12 }}>
                                {data?.document_status === 'new'
                                  ? 'PROFORMA #'
                                  : 'INVOICE #'}
                              </p>
                              <p>{data?.code}</p>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                              }}
                            >
                              <p className="bold mb-0" style={{ fontSize: 12 }}>
                                PERIODE PROJECT
                              </p>
                              <p>{formatDate(data?.periode_project, 'YYYYMM')}</p>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                              }}
                            >
                              <p className="bold mb-0" style={{ fontSize: 12 }}>
                                TANGGAL INVOICE
                              </p>
                              <p>
                                {data?.document_status === 'new'
                                  ? formatDate(data?.created_at, 'DD/MM/YYYY')
                                  : formatDate(data?.schedule_at, 'DD/MM/YYYY')}
                              </p>
                            </div>
                            {data?.document_status !== 'new' && (
                              <>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <p
                                    className="bold mb-0"
                                    style={{ fontSize: 12 }}
                                  >
                                    JATUH TEMPO
                                  </p>
                                  <p>
                                    {formatDate(data?.due_at, 'DD/MM/YYYY')}
                                  </p>
                                </div>
                                {data?.term_of_payment > 0 && (
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <p
                                      className="bold mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      TOP
                                    </p>
                                    <p>{data?.term_of_payment} Hari</p>
                                  </div>
                                )}
                              </>
                            )}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </>
                )}

                <div style={{ marginTop: 10 }}>
                  <table className="body ">
                    <thead className="" style={{ backgroundColor: '#2f83ba' }}>
                      <tr
                        style={{
                          verticalAlign: 'center',
                          WebkitPrintColorAdjust: 'exact',
                        }}
                      >
                        <td
                          className="center tb-spacing"
                          style={{
                            width: '5%',
                          }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 11 }}
                          >
                            #
                          </p>
                        </td>
                        <td
                          className="left tb-spacing"
                          style={{ width: '43%' }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 11 }}
                          >
                            SERVICES
                          </p>
                        </td>
                        <td
                          className="right tb-spacing"
                          style={{ width: '18%' }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 11 }}
                          >
                            QTY
                          </p>
                        </td>
                        <td
                          className="right tb-spacing"
                          style={{ width: '15%' }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 11 }}
                          >
                            UNIT PRICE
                          </p>
                        </td>
                        <td
                          className="right tb-spacing"
                          style={{ width: '15%' }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 11 }}
                          >
                            DISCOUNT
                          </p>
                        </td>
                        <td
                          className="right tb-spacing"
                          style={{ width: '15%', padding: 5 }}
                        >
                          <p
                            className="bold mb-0 text-white"
                            style={{ fontSize: 11 }}
                          >
                            SUBTOTAL
                          </p>
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      {p?.map((d, i) => (
                        <tr key={i} style={{ verticalAlign: 'center' }}>
                          <td
                            className="center bordered tb-spacing"
                            style={{
                              paddingTop: 5,
                              paddingBottom: 5,
                            }}
                          >
                            <p className="mb-0">
                              {d?.no}
                            </p>
                          </td>
                          <td
                            className="left bordered tb-spacing"
                            style={{
                              paddingTop: 5,
                              paddingBottom: 5,
                            }}
                          >
                            <div className="table-col">
                              <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
                                {d?.product?.name || '-'}
                              </div>
                              <small
                                className="info text-uppercase"
                                style={{
                                  textTransform: 'uppercase',
                                  fontSize: 9,
                                  lineHeight: 1.2,
                                  marginTop: 5,
                                }}
                              >
                                {d?.description}
                              </small>
                            </div>
                          </td>
                          <td
                            className="right bordered tb-spacing"
                            style={{
                              paddingTop: 5,
                              paddingBottom: 5,
                            }}
                          >
                            <p className="mb-0 text-capitalize">
                              {currencyFormat(d?.quantity, '') +
                                ' ' +
                                d?.unit?.unit}
                            </p>
                          </td>
                          <td
                            className="right bordered tb-spacing"
                            style={{
                              paddingTop: 5,
                              paddingBottom: 5,
                              paddingRight: 5,
                            }}
                          >
                            <p className="mb-0">
                              {currencyFormat(d?.unit_price, '')}
                            </p>
                          </td>
                          <td
                            className="right bordered tb-spacing"
                            style={{
                              paddingTop: 5,
                              paddingBottom: 5,
                              paddingRight: 5,
                            }}
                          >
                            <p className="mb-0">
                              {currencyFormat(d?.discount, '')}
                            </p>
                          </td>
                          <td
                            className="right bordered tb-spacing"
                            style={{
                              paddingTop: 5,
                              paddingBottom: 5,
                              paddingRight: 5,
                            }}
                          >
                            <p className="mb-0">
                              {currencyFormat(d?.unit_nett, '')}
                            </p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {page?.length === id + 1 && (
                  <>
                    <div style={{ marginTop: 5 }}>
                      <table>
                        <tr style={{ verticalAlign: 'top' }}>
                          <td style={{ width: '50%' }}>
                            <table
                              className="body"
                              style={{ marginTop: 10, lineHeight: 1 }}
                            >
                              <tr>
                                <td>
                                  <p className="bold" style={{ fontSize: 12 }}>
                                    Catatan:{' '}
                                  </p>
                                </td>
                              </tr>
                              <tr className="" style={{ verticalAlign: 'top', whiteSpace: 'pre' }}>
                                <td>
                                  <p className="mb-0">{data?.note}</p>
                                </td>
                              </tr>
                            </table>
                            <table className="body" style={{ marginTop: 15 }}>
                              <tr style={{ verticalAlign: 'top' }}>
                                <td>
                                  <p className="bold" style={{ fontSize: 12 }}>
                                    Terbilang
                                  </p>
                                  <p className="mt-0">{`${terbilang(
                                    data?.total_charges - data?.total_paid
                                  )} Rupiah`}</p>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td style={{ width: '50%' }}>
                            <table
                              className="body"
                              style={{ marginTop: 10, lineHeight: 0 }}
                            >
                              <tr style={{ verticalAlign: 'center' }}>
                                <td className="right" style={{ width: '50%' }}>
                                  <p className="mb-0" style={{ fontSize: 12 }}>
                                    Subtotal
                                  </p>
                                </td>
                                <td
                                  className="right"
                                  style={{
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    paddingRight: 5,
                                  }}
                                >
                                  <p className="mb-0" style={{ fontSize: 12 }}>
                                    {currencyFormat(data?.subtotal_price, '')}
                                  </p>
                                </td>
                              </tr>
                              {data?.subtotal_discount > 0 && (
                                <tr style={{ verticalAlign: 'center' }}>
                                  <td
                                    className="right"
                                    style={{ width: '50%' }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      Diskon Perbaris
                                    </p>
                                  </td>
                                  <td
                                    className="right"
                                    style={{
                                      paddingTop: 10,
                                      paddingBottom: 10,
                                      paddingRight: 5,
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      {currencyFormat(
                                        data?.subtotal_discount,
                                        ''
                                      )}
                                    </p>
                                  </td>
                                </tr>
                              )}
                              {data?.discount > 0 && (
                                <tr style={{ verticalAlign: 'center' }}>
                                  <td
                                    className="right"
                                    style={{ width: '50%' }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      Diskon
                                    </p>
                                  </td>
                                  <td
                                    className="right"
                                    style={{
                                      paddingTop: 10,
                                      paddingBottom: 10,
                                      paddingRight: 5,
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      {currencyFormat(data?.discount, '')}
                                    </p>
                                  </td>
                                </tr>
                              )}

                              {data?.taxes &&
                                data?.taxes.map((i) => (
                                  <tr style={{ verticalAlign: 'center' }}>
                                    <td
                                      className="right"
                                      style={{ width: '50%' }}
                                    >
                                      <p
                                        className="mb-0"
                                        style={{ fontSize: 12 }}
                                      >
                                        {i?.text}
                                      </p>
                                    </td>
                                    <td
                                      className="right"
                                      style={{
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                        paddingRight: 5,
                                      }}
                                    >
                                      <p
                                        className="mb-0"
                                        style={{ fontSize: 12 }}
                                      >
                                        {currencyFormat(i?.nominal, '')}
                                      </p>
                                    </td>
                                  </tr>
                                ))}

                              {data?.pph_percentage > 0 && (
                                <tr style={{ verticalAlign: 'center' }}>
                                  <td
                                    className="right"
                                    style={{ width: '50%' }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      PPh
                                    </p>
                                  </td>
                                  <td
                                    className="right"
                                    style={{
                                      paddingTop: 10,
                                      paddingBottom: 10,
                                      paddingRight: 5,
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      {`(${currencyFormat(
                                        data?.pph_nominal,
                                        ''
                                      )})`}
                                    </p>
                                  </td>
                                </tr>
                              )}

                              {data?.down_payment > 0 && (
                                <tr style={{ verticalAlign: 'center' }}>
                                  <td
                                    className="right"
                                    style={{ width: '50%' }}
                                  >
                                    <p
                                      className="bold mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      Pemotongan
                                    </p>
                                  </td>
                                  <td
                                    className="right"
                                    style={{
                                      paddingTop: 10,
                                      paddingBottom: 10,
                                      paddingRight: 5,
                                    }}
                                  >
                                    <p
                                      className="bold mb-0"
                                      style={{ fontSize: 12 }}
                                    >
                                      {`(${currencyFormat(
                                        data?.down_payment,
                                        'Rp.'
                                      )})`}
                                    </p>
                                  </td>
                                </tr>
                              )}
                              <tr style={{ verticalAlign: 'center' }}>
                                <td className="right" style={{ width: '50%' }}>
                                  <p
                                    className="bold mb-0"
                                    style={{ fontSize: 12 }}
                                  >
                                    Total
                                  </p>
                                </td>
                                <td
                                  className="right"
                                  style={{
                                    paddingTop: 10,
                                    paddingBottom: 10,
                                    paddingRight: 5,
                                  }}
                                >
                                  <p
                                    className="bold mb-0"
                                    style={{ fontSize: 12 }}
                                  >
                                    {currencyFormat(data?.total_charges, 'Rp.')}
                                  </p>
                                </td>
                              </tr>
                              {data?.total_paid > 0 && (
                                <>
                                  <tr style={{ verticalAlign: 'center' }}>
                                    <td
                                      className="right"
                                      style={{ width: '50%' }}
                                    >
                                      <p
                                        className="mb-0"
                                        style={{ fontSize: 12 }}
                                      >
                                        Total Dibayarkan
                                      </p>
                                    </td>
                                    <td
                                      className="right"
                                      style={{
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                        paddingRight: 5,
                                      }}
                                    >
                                      <p
                                        className="mb-0"
                                        style={{ fontSize: 12 }}
                                      >
                                        {currencyFormat(data?.total_paid, '')}
                                      </p>
                                    </td>
                                  </tr>
                                  <tr style={{ verticalAlign: 'center' }}>
                                    <td
                                      className="right"
                                      style={{ width: '50%' }}
                                    >
                                      <p
                                        className="bold mb-0"
                                        style={{ fontSize: 12 }}
                                      >
                                        Sisa Tagihan
                                      </p>
                                    </td>
                                    <td
                                      className="right"
                                      style={{
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                        paddingRight: 5,
                                      }}
                                    >
                                      <p
                                        className="bold mb-0"
                                        style={{ fontSize: 12 }}
                                      >
                                        {currencyFormat(
                                          data?.total_charges -
                                            data?.total_paid,
                                          'Rp.'
                                        )}
                                      </p>
                                    </td>
                                  </tr>
                                </>
                              )}
                            </table>
                          </td>
                        </tr>
                      </table>
                    </div>

                    <div style={{ marginTop: 15 }}>
                      <table className="body">
                        <tr className="">
                          <td className="" style={{ width: '33%' }}>
                            {data?.document_status !== 'new' && (
                              <p className="bold mb-0" style={{ fontSize: 12 }}>
                                Informasi Pembayaran{' '}
                              </p>
                            )}
                          </td>
                          <td className="" style={{ width: '33%' }}></td>
                          <td className="center" style={{ width: '33%' }}>
                            <p className="mb-0" style={{ fontSize: 12 }}>
                              Finance Dept,
                            </p>
                          </td>
                        </tr>
                        <tr className="" style={{ verticalAlign: 'top' }}>
                          <td className="" style={{ width: '35%', height: 80 }}>
                            {data?.document_status !== 'new' && (
                              <>
                                <p className="mb-0">
                                  Nama Bank :{' '}
                                  <span className="bold">
                                    BANK CENTRAL ASIA (BCA)
                                  </span>
                                </p>
                                <p className="mb-0">
                                  Cabang Bank :{' '}
                                  <span className="bold">KCU WISMA ASIA</span>
                                </p>
                                <p className="mb-0">
                                  Nomor Akun Bank :{' '}
                                  <span className="bold">084-2449527</span>
                                </p>
                                <p className="mb-0">
                                  Atas Nama :{' '}
                                  <span className="bold">
                                    PT. ENVIO GLOBAL PERSADA
                                  </span>
                                </p>
                              </>
                            )}
                          </td>
                          <td
                            className=""
                            style={{ width: '33%', height: 80 }}
                          ></td>
                          <td
                            className=""
                            style={{ width: '33%', height: 80, padding: 0 }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'stretch',
                                textAlign: 'center',
                              }}
                            >
                              {data?.total_charges < 5000000 && (
                                <img src="https://s3.ap-southeast-1.amazonaws.com/envio.co.id/assets/ttd-invoice.png" alt="" height="100px" />
                              )}

                              <p
                                className="mb-0 bold"
                                style={{
                                  fontSize: 10,
                                  textDecoration: 'underline',
                                  paddingTop: data?.total_charges < 5000000 ? 10: 80
                                }}
                              >
                                ENVIO LOGISTICS
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </>
                )}
              </section>
            ))}
          </>
        )}
      />
    </div>
  );
};

export default PrintReceivable;
